import type { ContractStatusEnum } from 'gql/graphql';
import type { IUseAccess } from 'hooks/useAccess';
import { Button, IconExpand, Loader } from 'uikit';

import type { ICellRendererParams } from 'ag-grid-community';
import React, { useCallback } from 'react';

import { PriceListUerRowMenu } from '../../PriceListUerRowMenu';
import type { RowData } from '../types';

const Style = { display: 'flex', alignItems: 'center' };

interface IMenuCellRendererComponent extends ICellRendererParams<RowData> {
    contractStatus: ContractStatusEnum | undefined;
    handleExpandRow: (row: RowData['id']) => void;
    priceListRules: IUseAccess['priceList'];
}

export const UerMenuCellRendererComponent = ({
    contractStatus,
    data,
    handleExpandRow,
    priceListRules,
}: IMenuCellRendererComponent) => {
    const handleClickExpand = useCallback(() => {
        if (data) {
            handleExpandRow(data.id);
        }
    }, [data, handleExpandRow]);

    if (!data) {
        return <Loader />;
    }

    if (!contractStatus) {
        return null;
    }

    return (
        <div style={Style}>
            {contractStatus && (
                <PriceListUerRowMenu row={data} contractStatus={contractStatus} priceListRules={priceListRules} />
            )}
            <Button onClick={handleClickExpand} iconLeft={IconExpand} onlyIcon view="clear" size="xs" />
        </div>
    );
};

UerMenuCellRendererComponent.displayName = 'UerMenuCellRendererComponent';
